import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

class Navigation extends React.Component {
  render() {
    return (
      <Navbar bg="light" variant="light" expand="md" fixed="top">
        <div className="container">
          <Navbar.Brand as={Link} to="/">
            JSONHelper.io
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mx-auto nav-fill w-100">
              <Nav.Link as={Link} to="/tool">
                Tool
              </Nav.Link>
              <Nav.Link as={Link} to="/what-is-json">
                What is JSON
              </Nav.Link>
              <Nav.Link as={Link} to="/how-it-works">
                How Editor Works
              </Nav.Link>
              <Nav.Link as={Link} to="/contact">
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    );
  }
}

export default Navigation;